jQuery(document).ready(function ($) {
    $('.menu-item-has-children > a').click(function (e) {
        e.preventDefault();
        if ($(this).parent().children('.menu').hasClass('is-open')) {
            closeSubMenu($(this));
        } else {
            closeSubMenu($('.menu-item-has-children > a'));
            openSubMenu($(this));
        }
    });
    $(document).click(function (e) {
        if (!$(e.target).closest('.menu').length) {
            closeSubMenu($('.menu-item-has-children > a'));
        } else {

        }
    });
});

function openSubMenu($this) {
    $this.parent().children('.menu').addClass('is-open');
    $this.parent().addClass('is-open');
}

function closeSubMenu($this) {
    $this.parent().children('.menu').removeClass('is-open');
    $this.parent().removeClass('is-open');

}

jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() > 100) {
        jQuery('.header__logo').addClass('header__logo--scrolled');
    } else {
        jQuery('.header__logo').removeClass('header__logo--scrolled');

    }
});

jQuery(document).ready(function ($) {
    $('.search-button').click(function (e) {
        e.preventDefault();
        $('#search_form').submit();
    });
});